import React from 'react'
import { Box } from '../../Components/Layout'
import { Desc, Head2 } from '../../Components/Typography/Text.styles'
import { ExlainerList, ExplainerCon } from './styles'

export const Explainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Box noMargin>
      <ExplainerCon>
        <Head2>Free Agency</Head2>
        <Desc>
          {`Free Agency is a status afforded to players who are able to negotiate a contract with any club. A player will become eligible for Free Agency:`}
        </Desc>
        <ExlainerList>
          <li>{`When the player’s existing contract expires`}</li>
          <li>
            {`If the player is not on his club’s active roster for 30% or more of eligible games, and The Player must remain with his Club for more than 50% of the Season (the player is not considered eligible while on the Injured List, Family or Medical Leave List).`}
          </li>
        </ExlainerList>
        <Head2>{`30% Threshold`}</Head2>
        <Desc>{`Players who did not meet the 30% threshold during 2024:`}</Desc>
        <ExlainerList>
          <li>{`Colby Barsz (Archers)`}</li>
          <li>{`Jack DiBenedetto (Archers)`}</li>
          <li>{`Eli Fisher (Archers)`}</li>
          <li>{`Jack VanOverbeke (Archers)`}</li>
          <li>{`Carter Parlette (Cannons)`}</li>
          <li>{`Mike Robinson (Cannons)`}</li>
          <li>{`Matt Knote (Outlaws)`}</li>
          <li>{`Saam Olexo (Outlaws)`}</li>
          <li>{`Ron John (Redwoods)`}</li>
          <li>{`Alex Simmons (Redwoods)`}</li>
          <li>{`Michael Boehm (Waterdogs)`}</li>
          <li>{`Thomas McConvey (Waterdogs)`}</li>
          <li>{`Petey Lasalla (Whipsnakes)`}</li>
        </ExlainerList>

        <Head2>{`Difference between Waivers and Free Agency`}</Head2>
        <Desc>{`Waiver periods are for players who have been released prior to their contract’s expiration.`}</Desc>
        <br />
        <Desc>{`If a player is claimed on waivers, he will stay on his current contract length and compensation.`}</Desc>
        <br />
        <Desc>{`If a player clears waivers, that player becomes a free agent able to negotiate a contract with any club. Their contract is terminated and a new contract with updated terms will be issued upon an agreement being reached.`}</Desc>
        <br />

        <Head2>{`Timeline`}</Head2>
        <ExlainerList>
          <li>{`February 18, 2025 at 12:00PM ET: Open discussion period begins; coaches may contact players whose previous contracts are due to expire`}</li>
          <li>
            {`March 3, 2025 at 12:00PM ET: First Off-Season Free Agency Period opens`}
          </li>
          <li>{`March 3, 2025 at 12:00PM ET: First Off-Season Waiver Period opens`}</li>
          <li>
            {`April 1, 2025 at 12:01AM ET: Deadline for players who were not on their club’s Active Roster for 30% or more of eligible games to sign with a different club`}
          </li>
          <li>{`College Draft date (TBD) at 2:00PM ET: First Off-Season Free Agency Period closes`}</li>
          <li>
            {`College Draft date (TBD) at 2:00PM ET: First Off-Season Waiver Period closes`}
          </li>
          <li>
            {`Post-College Draft: Rosters expand from 25 to 30-man rosters ahead of Training Camp`}
          </li>
          <li>{`Date TBD: Second Off-Season Free Agency Period opens`}</li>
          <li>{`Date TBD: Second Off-Season Waiver Period opens`}</li>
          <li>
            {`Two weeks before training camp at 2:00PM ET: Second Off-Season Free Agency Period closes`}
          </li>
          <li>{`Two weeks before training camp at 2:00PM ET: Second Off-Season Waiver Period closes`}</li>
        </ExlainerList>
      </ExplainerCon>
    </Box>
  )
}
